<template>
  <patient-profile>
    <modal-dialog
      title="Примечание"
      content-class="modal-patient-appointment-note"
      max-width="720px"
      v-bind:value="shownAppointmentNoteModal"
      v-on:input="onCloseAppointmentNoteModal"
      with-cross
    >
      <p class="modal-patient-appointment-note__text">
        {{ appointmentNote }}
      </p>
    </modal-dialog>
    <div class="patient-appointments">
      <form
        class="patient-appointments__filters"
        v-on:change.prevent="filterAppointments"
        v-on:submit.prevent
      >
        <label class="patient-appointments__filters__item">
          <input type="radio" v-model="filterType" name="filter" checked value="">
          <span class="not">Все <span>{{ appointmentCounts.all }}</span></span>
        </label>
        <label class="patient-appointments__filters__item">
          <input type="radio" v-model="filterType" name="filter" value="confirmed">
          <span class="confirmed">Подтвержден <span>{{ appointmentCounts.confirmed }}</span></span>
        </label>
        <label class="patient-appointments__filters__item">
          <input type="radio" v-model="filterType" name="filter" value="unconfirmed">
          <span class="unconfirmed">Не подтвержден <span>{{ appointmentCounts.unconfirmed }}</span></span>
        </label>
        <label class="patient-appointments__filters__item">
          <input type="radio" v-model="filterType" name="filter" value="came">
          <span class="came">Пациент пришел <span>{{ appointmentCounts.came }}</span></span>
        </label>
        <label class="patient-appointments__filters__item">
          <input type="radio" v-model="filterType" name="filter" value="canceled">
          <span class="canceled">Отменен <span>{{ appointmentCounts.canceled }}</span></span>
        </label>
        <label class="patient-appointments__filters__item">
          <input type="radio" v-model="filterType" name="filter" value="absent">
          <span class="absent">Неявка <span>{{ appointmentCounts.absent }}</span></span>
        </label>
      </form>
      <div class="patient-appointments__row">
        <h2 class="patient-appointments__row__title">Записи на прием</h2>
        <button
          v-if="hasAddVisit"
          class="patient-appointments__row__button-add"
          type="button"
          v-on:click="onOpenSchedule"
        >
          Записать на прием
        </button>
      </div>
      <appointment-table
        v-bind:actions="actions"
        v-bind:is-sort-by-date="isSortByDate"
        v-bind:appointment-list="appointments"
        v-on:on-sort-by-date="onSortByTime"
        v-on:on-open-note-modal="openNoteModal"
        v-on:open-appointment="openAppointment"
      />
    </div>
    <side-slide-transition>
      <confirm-side-dialog
        label="Запись на прием"
        v-if="isShowAppointmentForm"
        v-bind:need-confirm="needConfirmAppointmentForm"
        v-on:cancel="onCloseAppointmentForm">
        <form-appointment-creation
          method="dialog"
          show-update-status-buttons
          v-bind:is-selected-appointments="wasSelectedAppointment"
          v-bind:rejection-reason-list="rejectionReasons"
          v-bind:advertising-channel-list="advertisingChannels"
          v-bind:can-change-patient="false"
          v-bind:can-create-patients="false"
          v-bind:can-edit-initial="canEditInitial"
          v-bind:is-disabled-field="true"
          v-bind:employee-list="initialDoctorList"
          v-bind:employee-timeline="appointmentEmployeeTimeline"
          v-bind:employee-work-days="appointmentEmployeeWorkDays"
          v-bind:favorite-services="services.favorites"
          v-bind:initial-date="appointmentDate"
          v-bind:initial-employee-id="appointmentEmployeeId"
          v-bind:initial-month="appointmentMonth"
          v-bind:initial-time-ends="appointmentTimeEnds"
          v-bind:initial-time-starts="appointmentTimeStarts"
          v-bind:input-errors="appointmentInputErrors"
          v-bind:is-await-request="isAppointmentAwaitRequest"
          v-bind:matched-patients="appointmentMatchedPatients"
          v-bind:patient-list="patientList"
          v-bind:service-list="services.all"
          v-bind="appointmentProps"
          v-on:came="onCame"
          v-on:cancel="onCancel"
          v-on:change-values="onChangeAppointmentFieldValues"
          v-on:close="onCloseAppointmentForm"
          v-on:confirm="onConfirm"
          v-on:create-advertising-channel="onCreateAdvertisingChannel"
          v-on:input-date="onInputAppointmentDate"
          v-on:input-employee="onInputAppointmentEmployee"
          v-on:input-month="onInputAppointmentMonth"
          v-on:input-times="onInputAppointmentTimes"
          v-on:match-patients="onMatchedPatients"
          v-on:open-visit="onOpenVisit"
          v-on:reload-timeline="onReloadEmployeeDayTimeline"
          v-on:submit-editing="onSubmit"
          v-on:restore="onRestore"
        />
      </confirm-side-dialog>
    </side-slide-transition>
  </patient-profile>
</template>

<script>
import { List, Maybe, None } from 'monet';
import notifierMixin from '@/mixins/notifierMixin';
import dateMixin from '@/mixins/dateMixin';
import AppointmentTable from '@/components/AppointmentTable.vue';
import SideSlideTransition from '@/components/SideSlideTransition.vue';
import FormAppointmentCreation from '@/components/FormAppointmentCreation.vue';
import ConfirmSideDialog from '@/components/ConfirmSideDialog.vue';
import PatientProfile from '@/views/ClinicPanel/PatientProfile.vue';
import appointmentCreationMixin from '@/mixins/appointmentCreationMixin';
import ModalDialog from '@/components/ModalDialog.vue';
import { STORE_PARAMS } from '@/store/actions/schedule';
import metricMixin from '@/mixins/metricMixin';
import { GOAL_ADD_APPOINTMENT_PATIENT_APPOINTMENTS } from '@/plugins/metric';

/**
 * @description Примесь примечания записи на прием.
 */
const appointmentNoteMixin = {
  data() {
    return {
      /**
       * @description Примечание записи на прием.
       */
      appointmentNote: '',
      /**
       * @description Отображение модального окна примечания записи на прием.
       */
      shownAppointmentNoteModal: false,
    };
  },
  methods: {
    /**
     * @description Открыть модальное окно примечания записи на прием.
     * @param note
     * @returns {void}
     */
    openNoteModal(note) {
      this.appointmentNote = note;
      this.shownAppointmentNoteModal = true;
    },
    /**
     * @description Обработать закрытие модального окна примечания записи на прием.
     * @returns {void}
     */
    onCloseAppointmentNoteModal() {
      this.shownAppointmentNoteModal = false;
      this.appointmentNote = '';
    },
  },
};

export default {
  components: {
    ModalDialog,
    PatientProfile,
    AppointmentTable,
    SideSlideTransition,
    FormAppointmentCreation,
    ConfirmSideDialog,
  },
  computed: {
    /**
     * Идёт ли сортировка по дате
     *
     * @return {boolean}
     */
    isSortByDate() {
      return this.sortByDate !== '';
    },
    /**
     * @description Может добавлять визиты.
     * @type {boolean}
     */
    hasAddVisit() {
      return this.actions.includes('add');
    },
    /**
     * @description Идентификатор пациента.
     * @type {number}
     */
    patientId: ({ $route }) => parseInt($route.params.id, 10),
    /**
     * @description Список услуг.
     * @type {any[]}
     */
    services: ({ serviceList, fetchServiceList }) => serviceList.orLazy(fetchServiceList),
    /**
     * @description Запись на прием выбрана.
     * @type {bool}
     */
    wasSelectedAppointment() {
      return this.selectedAppointment.fold(false)(({ id }) => !!id);
    },
  },
  created() {
    this.fetchProfileForAppointments(this.patientId);
    this.reloadAppointmentList();
    this.fetchAdvertisingChannelList();
    this.fetchRejectionReasonList();
  },
  data() {
    return {
      /**
       * Фильтр сортировки по дате
       * @type {String}
       */
      sortByDate: 'desc',
      /**
       * @description Допустимые действия.
       * @type {Sting[]}
       */
      actions: [],
      /**
       * @description Запись на прием.
       * @type {any}
       */
      appointment: null,
      /**
       * @description Список записей на прием.
       * @type {Array}
       */
      appointments: [],
      /**
       * @description Количества записей по статусам
       */
      appointmentCounts: {},
      /**
       * @description Список отмененных записей на прием.
       * @type {List<any>}
       */
      canceledAppointments: List(),
      /**
       * @description Тип сортировки
       * @type String
       */
      filterType: '',
      /**
       * @description Начальный список докторов.
       * @type {any[]}
       */
      initialDoctorList: [],
      /**
       * @description Нарушение ограничений.
       * @type {any}
       */
      inputErrors: {},
      /**
       * @description Ожидание окончания запроса.
       * @type {boolean}
       */
      isAwaitRequest: false,
      /**
       * @description Список услуг.
       * @type {Maybe<any[]>}
       */
      serviceList: None(),
      /**
       * @description Список пациентов
       */
      patientList: [],
      /**
       * @description Пациент архивный.
       */
      patientIsArchive: false,
      /**
       * @description Нужно подтверждение перед закрытием формы.
       * @type {boolean}
       */
      needConfirmAppointmentForm: false,
      /**
       * @description Нужно подтверждение перед закрытием формы.
       * @type {boolean}
       */
      needConfirmAppointmentFormCreation: false,
      /**
       * @description Форма создания записи открыта
       */
      isOpenAppointmentFormCreation: false,
      /**
       * @description Текущая дата.
       */
      currentDate: this.formatDateToISO(new Date()),
      initialAppointmentTimeStarts: '',
      initialAppointmentTimeEnds: '',
    };
  },
  methods: {
    /**
     * Обработать событие - изменение сортировки по времени.
     *
     * @param order {string}
     */
    onSortByTime(order) {
      this.sortByDate = order;
      this.reloadAppointmentList();
    },
    /**
     * @description Обработать получение шкалы времени сотрудника на день.
     * @param {number} employeeId
     * @param {string} isoDate
     * @param {string} timeStarts
     * @returns {void}
     */
    onReloadTimeline(employeeId, isoDate, timeStarts) {
      this
        .fetchEmployeeDayTimeline(employeeId, isoDate, timeStarts)
        .then(({ actuallyPeriods, timeline }) => {
          this.appointmentEmployeeTimeline = timeline;
          const isEmptyTime = !this.appointmentTimeStarts && !this.appointmentTimeEnds;
          const needUpdate = actuallyPeriods.length > 0 && isEmptyTime;
          if (needUpdate) {
            const { from, to } = actuallyPeriods[0];
            this.initialAppointmentTimeStarts = from.title;
            this.initialAppointmentTimeEnds = to.title;
          }
        });
    },
    /**
     * @description Обработать перезагрузку списка работающих сотрудников.
     * @param {string} dateISO Дата в формате ISO.
     * @returns {void}
     */
    onReloadEmployeeList(dateISO) {
      this
        .fetchWorkEmployees(dateISO)
        .then((employees) => { this.appointmentWorkEmployees = employees; });
    },
    /**
     * @description Получить данные записи на прием.
     * @param {number} appointmentId Идентификатор записи на прием.
     * @param {number} employeeId    Идентификатор сотрудника.
     * @returns {Promise<any>}
     */
    async fetchAppointment(appointmentId, employeeId) {
      const onFail = (error) => {
        this.notifyFail(error.title);
        return null;
      };
      const onSuccess = (visit) => {
        this.inputErrors = {};
        return visit;
      };
      const either = await this.$appointmentScheduleGateway.getById(employeeId, appointmentId);
      return either.fold(onFail, onSuccess);
    },
    /**
     * @description Затянуть профиль пациента для записей
     * @param patientId
     * @returns {Promise<void>}
     */
    async fetchProfileForAppointments(patientId) {
      const onFail = (error) => {
        this.notifyFail(error.title);
      };
      const onSuccess = ({ actions, patient }) => {
        this.actions = actions;
        this.patientList = [
          {
            advertisingChannelId: patient.advertising_channel_id,
            advertisingChannelName: patient.advertising_channel_name,
            id: patient.id,
            name: patient.name,
            labels: patient.labels,
          },
        ];
        this.patientIsArchive = patient.is_archive;
      };
      const either = await this.$patientGateway.getPatientProfileForAppointmentHistory(patientId);
      either.fold(onFail, onSuccess);
    },
    /**
     * @description Получить список услуг.
     * @returns {{ all: ServiceItem[], favorite: ServiceItem[] }}
     */
    fetchServiceList() {
      this.$serviceGateway.allWithFavoritesForView().then((result) => {
        this.serviceList = result;
      });
      return { all: [], favorite: [] };
    },
    /**
     * @description Отфильтровать
     */
    filterAppointments(event) {
      const filterType = event.target.value;
      this.filterType = filterType;
      this.reloadAppointmentList(filterType);
    },
    /**
     * @description Обработать приход пациента.
     * @param {number} id Идентификатор записи на прием.
     * @returns {void}
     */
    async onCame(id) {
      if (this.patientIsArchive) {
        this.notifyFail('Установлен запрет записи на прием');
        return;
      }
      this.isAppointmentAwaitRequest = true;
      await this
        .$appointmentScheduleGateway
        .came(id)
        .then(this.onResponse)
        .finally(() => { this.isAppointmentAwaitRequest = false; });
    },
    /**
     * @description Обработать отмену записи на прием.
     * @param id
     * @param cause
     * @param rejectReasonId
     * @param customRejectReason
     * @returns {Promise<void>}
     */
    async onCancel(id, cause, rejectReasonId, customRejectReason) {
      this.isAppointmentAwaitRequest = true;
      await this
        .$appointmentScheduleGateway
        .cancel(
          id,
          cause,
          rejectReasonId,
          customRejectReason,
        )
        .then(this.onResponse)
        .finally(() => { this.isAppointmentAwaitRequest = false; });
    },
    /**
     * @description Обработать подтверждение записи на прием.
     * @param {number} id Идентификатор записи на прием.
     * @returns {void}
     */
    async onConfirm(id) {
      if (this.patientIsArchive) {
        this.notifyFail('Установлен запрет записи на прием');
        return;
      }
      this.isAppointmentAwaitRequest = true;
      await this
        .$appointmentScheduleGateway
        .confirm(id)
        .then(this.onResponse)
        .finally(() => { this.isAppointmentAwaitRequest = false; });
    },
    /**
     * @description Обработать создание записи на прием.
     * @param {AppointmentExistPatientCreationRequest} request Запрос.
     * @returns {void}
     */
    onCreate(request) {
      this.isAppointmentAwaitRequest = true;
      this
        .$appointmentScheduleGateway
        .createWithExistPatient(request)
        .then(this.onResponse)
        .finally(() => { this.isAppointmentAwaitRequest = false; });
    },
    /**
     * @description Обработать редактирование записи на прием.
     * @param {AppointmentExistPatientCreationRequest} request Запрос.
     * @param {number}                                 id      Идентификатор записи на прием.
     * @returns {void}
     */
    onEdit(request, id) {
      this.isAppointmentAwaitRequest = true;
      this
        .$appointmentScheduleGateway
        .editWithExistPatient(request, id)
        .then(this.onResponse)
        .finally(() => { this.isAppointmentAwaitRequest = false; });
    },
    /**
     * @description Обработать переход к визиту.
     * @returns {void}
     */
    async onOpenVisit() {
      const appointmentVisitId = this.selectedAppointment.fold({})(({ visitId }) => visitId);
      await this.$router.push({
        name: 'ClinicPanelPatientVisit',
        params: {
          id: this.patientId,
          visitId: appointmentVisitId,
        },
      });
    },
    /**
     * @description Обработать переход на расписание.
     * @returns {void}
     */
    onOpenSchedule() {
      if (this.patientIsArchive) {
        this.notifyFail('Установлен запрет записи на прием');
        return;
      }
      const params = { patientId: this.patientId };
      this.reachGoalIfNotReach(GOAL_ADD_APPOINTMENT_PATIENT_APPOINTMENTS);
      this.$store.commit(
        STORE_PARAMS,
        params,
      );
      this.$router.push({
        name: 'ClinicPanelAppointmentScheduleEmployees',
        params,
      });
    },
    /**
     * @description Обработать изменение значений полей формы.
     * @param {string}  form     Название формы.
     * @param {boolean} isChange Есть изменения.
     * @returns {void}
     */
    onChangeAppointmentFieldValues(form, isChange) {
      this.needConfirmAppointmentForm = isChange;
    },
    /**
     * @description Обработать ответ.
     * @param {Either} response
     * @returns {void}
     */
    onResponse(response) {
      const onFail = (error) => {
        const failurePairs = (error.causes || []).map((cause) => [cause.source, cause.details]);
        this.inputErrors = Object.fromEntries(failurePairs);
        this.appointmentInputErrors = Object.fromEntries(failurePairs);
        if (failurePairs.length === 0) {
          this.clarifyAndNotifyFail(error.interaction)(
            error.title,
            error.detail || '',
            error.telegramLink,
            error.whatsAppLink,
          );
        }
      };
      const onSuccess = (message) => {
        this.notifySuccess(message);
        this.onCloseAppointmentForm();
        this.isOpenAppointmentFormCreation = false;
        this.reloadAppointmentList(this.filterType);
      };
      response.fold(onFail, onSuccess);
    },
    /**
     * @description Обработать восстановление записи на прием.
     * @returns {void}
     * @param request
     */
    async onRestore(request) {
      const appointmentId = this.selectedAppointment.fold({})(({ id }) => id);
      this.onResponse(await this.$appointmentScheduleGateway.restore(appointmentId, request));
    },
    /**
     * @description Обработать сохранение записи на прием.
     * @param {AppointmentExistPatientCreationRequest} request Запрос.
     * @returns {void}
     */
    onSubmit(request) {
      if (this.patientIsArchive) {
        this.notifyFail('Установлен запрет записи на прием');
        return;
      }
      const appointmentId = this.selectedAppointment.fold({})(({ id }) => id);
      if (appointmentId) {
        this.onEdit(request, appointmentId);
      } else {
        this.onCreate(request);
      }
    },
    /**
     * @description Открыть запись на прием.
     * @param {any} appointment Запись на прием.
     * @returns {void}
     */
    async openAppointment(appointment) {
      this.onCloseAppointmentForm();
      const visit = await this.fetchAppointment(appointment.id, appointment.employeeId);
      if (visit) {
        this.appointmentDate = new Date(appointment.date);
        this.appointmentMonth = appointment.date.split('-').slice(0, 1).join('-');
        this.onInputAppointmentTimes(appointment.startsTime, appointment.endsTime);
        this.onInputAppointmentEmployee(appointment.employeeId);
        this.initialDoctorList = [
          {
            id: appointment.employeeId,
            name: appointment.employeeName,
          },
        ];
        this.patientList = [
          {
            advertisingChannelId: visit.advertisingChannel.id,
            advertisingChannelName: visit.advertisingChannel.name,
            id: visit.patientId,
            name: visit.patientName,
            labels: visit.patientLabels,
          },
        ];
        this.selectedAppointment = Maybe.fromEmpty(visit);
      }
    },
    /**
     * @description Распечатать план.
     * @returns {void}
     */
    printPage() {
      window.print();
    },
    /**
     * @description Перезагрузить список записей на прием пациента.
     * @param filterType
     * @return {Promise<void>}
     */
    async reloadAppointmentList(filterType = '') {
      const onFail = (error) => {
        this.notifyFail(error.getTitle());
        this.appointments = [];
      };
      const onSuccess = ({ actions, appointments, counts }) => {
        this.actions = actions;
        this.appointments = appointments;
        this.appointmentCounts = counts;
      };
      await this
        .$appointmentScheduleGateway
        .viewFilteredAppointmentListByPatientId(this.patientId, filterType, this.sortByDate)
        .then((result) => {
          result.fold(onFail, onSuccess);
        });
    },
  },
  mixins: [
    metricMixin,
    appointmentCreationMixin,
    dateMixin,
    notifierMixin,
    appointmentNoteMixin,
  ],
  name: 'ClinicPanelPatientAppointments',
};
</script>

<style lang="scss" scoped>
@use "@/scss/buttons";

.modal-patient-appointment-note {
  &__text {
    font-size: 16px;
  }
}

.patient-appointments {
  display: flex;
  flex-direction: column;
  margin-top: 37px;
  &__row {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-content: center;
    &__title {
      color: #192a3e;
      font-size: 24px;
      font-weight: 600;
      line-height: 29px;
      margin: 31px 0 7px 0;
    }
    &__button-add {
      margin-top: 20px;
      @include buttons.btn-transparent(100%, 40px, 16px);
      max-width: 200px;
      &::before {
        content: "+";
        margin-right: 4px;
      }
    }
  }
  &__filters {
    display: flex;
    flex-flow: row wrap;
    gap: 6px;
    &__item {
      display: flex;
      align-items: center;
      cursor: pointer;
      &>input {
       position: absolute;
       z-index: -1;
       opacity: 0;
        &:checked+span {
          border-color: var(--action-color);
          border-width: 2px;
          padding: 7px 14px;
        }
        &:not(:disabled):not(:checked)+span:hover {
          border-color: var(--action-color);
          border-width: 2px;
          padding: 7px 14px;
        }
      }
      &>span {
       display: flex;
       align-items: center;
       user-select: none;
       color: var(--reading-color);
       font-size: 14px;
       line-height: 17px;
       height: 38px;
       padding: 8px 15px;
       border: 1px solid #c2cfe0;
       border-radius: 4px;
        &:before {
          content: '';
          margin: 0 11px 0 0;
          height: 20px;
          width: 20px;
        }
        &.not:before {
          content: none;
        }
        &.confirmed:before {
          background-image: url("@/assets/img/checked/checked-green.svg");
          background-repeat: no-repeat;
          background-size: contain;
          height: 15px;
          width: 15px;
        }
        &.unconfirmed:before {
          background-color: #abb1a3;
          border-radius: 50%;
          content: "";
          height: 6px;
          width: 6px;
        }
        &.came:before {
          background-image: url("@/assets/img/checked/all-checked-green.svg");
          background-repeat: no-repeat;
          background-size: contain;
          height: 20px;
          width: 20px;
        }
        &.canceled:before {
          background-image: url("@/assets/img/exit-red.svg");
          min-width: 20px;
          min-height: 20px;
        }
        &.absent:before {
          background-image: url("@/assets/img/status/absence-red.svg");
          min-width: 20px;
          min-height: 20px;
        }
        span {
          color: grey;
          margin: 0 0 0 5px;
        }
      }
    }
  }
}

@media screen and (max-width: 760px) {
  .patient-appointments {
    border-top: none;
  }
}

@media screen and (max-width: 600px) {
  .patient-appointments {
    &__row {
      flex-direction: column;
      margin: 0 0 20px 0;
      &__button-add {
        margin-top: 10px;
      }
    }
  }
}
</style>
